(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceTimeSessionServantDialogController', ServiceTimeSessionServantDialogController);

    ServiceTimeSessionServantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceTimeSessionServant', 'ServiceTimeSession', 'Servant'];

    function ServiceTimeSessionServantDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceTimeSessionServant, ServiceTimeSession, Servant) {
        var vm = this;

        vm.serviceTimeSessionServant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.servicetimesessions = ServiceTimeSession.query();
        vm.servicetimesessionservants = ServiceTimeSessionServant.query();
        vm.servants = Servant.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.serviceTimeSessionServant.id !== null) {
                ServiceTimeSessionServant.update(vm.serviceTimeSessionServant, onSaveSuccess, onSaveError);
            } else {
                ServiceTimeSessionServant.save(vm.serviceTimeSessionServant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceTimeSessionServantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
